import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Calendar } from 'lucide-react';
import { Badge } from './ui/badge';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1585829365295-ab7cd400c167?w=1200&h=800&fit=crop';

const FeaturedArticle = ({ article }) => {
  const getImageUrl = (url) => {
    if (!url) return FALLBACK_IMAGE;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/api/uploads') || url.startsWith('/uploads')) return `${API_URL}${url}`;
    return url;
  };

  return (
    <Link to={`/article/${article.id}`} className="block group">
      <div className="relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300">
        {/* Image */}
        <div className="relative h-96 overflow-hidden bg-gray-900">
          <img
            src={getImageUrl(article.image_url || article.image)}
            alt={article.title_english || article.titleEnglish}
            className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-500"
            onError={(e) => { e.target.src = FALLBACK_IMAGE; }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
          
          {/* Breaking Badge */}
          {(article.is_breaking || article.isBreaking) && (
            <div className="absolute top-4 left-4">
              <Badge className="bg-red-600 text-white px-3 py-1 text-xs font-bold uppercase">
                Breaking
              </Badge>
            </div>
          )}

          {/* Content Overlay */}
          <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
            <div className="flex items-center space-x-3 mb-3">
              <Badge className="bg-red-600 text-white px-3 py-1 text-xs uppercase font-semibold">
                {article.category_bengali || article.categoryBengali || article.category}
              </Badge>
              {article.location && <span className="text-sm">{article.location}</span>}
            </div>
            <h2 className="text-2xl md:text-3xl font-bold mb-2 leading-tight">
              {article.title_bengali || article.titleBengali}
            </h2>
            <p className="text-gray-200 text-sm md:text-base mb-3">
              {article.title_english || article.titleEnglish}
            </p>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex items-center space-x-1">
                <Calendar className="w-4 h-4" />
                <span>{article.date || new Date(article.created_at).toLocaleDateString()}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Eye className="w-4 h-4" />
                <span>{article.views || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedArticle;